import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const DefaultPage = () => {
    const navigate = useNavigate();
  return (
    <div>
       <Result
            status="404"
            title="404"
            subTitle="This page is not founded"
            extra={<Button type="primary" onClick={()=>navigate('/')} > backe to home </Button>}
        />
    </div>
  );
}

export default DefaultPage;
